export const FirestoreCollections = {
  Users: 'users',
  LifeAreas: 'life-areas',
  Tasks: 'tasks',
  Goals: 'goals',
  Tags: 'tags',
  Relationships: 'relationships',
  SmartLists: 'smart-lists',
  FcmTokens: 'fcm-tokens',
  ExternalConnections: 'external-connections',
  Visions: 'visions',
} as const;
